@if (currentAnnualDetailAssessment !== undefined) {
    <table class="table table-responsive grid annual-details-side-panel" style="max-width: 500px">
        <thead class="years">
            <tr style="height: 35px">
                <th colspan="4">{{ currentYear?.annualYear1 }}</th>
                <!--[data-sd-active-annual-yecurrentYeardYear.annualYear1'>-->
            </tr>
        </thead>
        <tbody class="details">
            <!-- Controls Row -->
            @if (consolidatingTypeId !== 2) {
                <tr>
                    <td colspan="3" class="ps-0">
                        @if (
                            navigationState.editMode &&
                            navigationState.viewTarget == ViewTarget.assessment &&
                            (currentAnnualDetailAssessment.status === 1 ||
                                !currentYear.calcProjected ||
                                !currentAnnualDetailAssessment.annualAssessmentID)
                        ) {
                            <button class="ace-btn btn-sm btn-primary btn-action mx-0" (click)="activateAddRevision()"
                                >Add Revision
                            </button>
                        }
                        <select
                            class="form-select form-select-sm"
                            [disabled]="navigationState.editMode"
                            [ngModel]="currentAnnualDetailAssessment"
                            (ngModelChange)="selectRev($event)"
                            style="float: right; max-width: 160px; margin-top: 3px; margin-right: -7px"
                        >
                            <!-- ng-options="rev as rev.revisionDesc for rev in active.year.annualGridDetails"-->
                            @for (rev of currentYear.annualGridDetails; track rev) {
                                <option [ngValue]="rev">{{ rev.revisionDesc }} </option>
                            }
                        </select>
                    </td>
                </tr>
            }
            <!-- Compliance Row -->
            @if (currentYear.complianceFilingTypeSummaries && currentYear.complianceFilingTypeSummaries.length > 0) {
                <tr>
                    <td class="heading" style="border: none"> Comp </td>
                    <td class="heading" style="border: none">
                        @for (filingType of currentYear.complianceFilingTypeSummaries; track filingType) {
                            <div style="white-space: nowrap">
                                {{ getComplianceFilingType(filingType.filingTypeId) }}
                            </div>
                        }
                    </td>
                    <td class="clickable" style="padding-right: 8px; border: none">
                        <div class="lines-active">
                            <div (click)="activateViewTarget(ViewTarget.compliance)">
                                @for (filingType of currentYear.complianceFilingTypeSummaries; track filingType) {
                                    <div
                                        [innerHtml]="
                                            annualDetailsService.getComplianceDisplay(
                                                filingType.filingTypeId,
                                                currentYear.complianceFilingTypeSummaries
                                            )
                                        "
                                    >
                                    </div>
                                }
                            </div>
                        </div>
                    </td>
                </tr>
            }
            <!-- Assessment Row -->
            <tr>
                <td class="heading" [class.not-actual-heading]="notActual()"> Asmts </td>
                <td class="heading" [class.not-actual-heading]="notActual()">
                    @for (
                        comp of annualDetailsService.nonCapComponents(
                            currentAnnualDetailAssessment?.annualGridComponents,
                            componentTypes,
                            viewTaxableValues
                        );
                        track comp
                    ) {
                        <div
                            >{{ annualDetailsService.getComponentName(comp, componentTypes) }}
                            <!-- | orderBy:compPos | filter:{efAction:'!delete'}" data-sd-assessment-component-name="{{getCompName(comp)}}">{{getCompName(comp)}}</div>--></div
                        >
                    }
                    @if (viewTaxableValues) {
                        <div class="sum-label">Total MV:</div>
                    } @else {
                        <div class="sum-label">Total FMV:</div>
                    }
                    @for (
                        comp of annualDetailsService.capComponents(
                            currentAnnualDetailAssessment.annualGridComponents,
                            componentTypes,
                            viewTaxableValues
                        );
                        track comp;
                        let i = $index
                    ) {
                        <div [ngClass]="{ 'cap-component': i === 0 }"
                            >{{ annualDetailsService.getComponentName(comp, componentTypes) }}
                        </div>
                    }
                    @if (viewTaxableValues) {
                        @for (
                            taxableLabel of annualDetailsService.taxableValueLabels(currentAnnualDetailAssessment);
                            track taxableLabel;
                            let i = $index
                        ) {
                            <div
                                class="taxable-value-label"
                                [ngClass]="{ 'cap-component': i === 0 }"
                                [title]="taxableLabel + ':'"
                                >{{ taxableLabel }}:</div
                            >
                        }
                    }
                </td>
                <td
                    class="clickable"
                    [class.not-actual-heading]="notActual()"
                    style="padding-right: 8px"
                    [style.cursor]="notAllowedIfConsolidated"
                >
                    <div class="lines-active" [style.cursor]="notAllowedIfConsolidated">
                        <div (click)="activateViewTarget(ViewTarget.assessment)">
                            @for (
                                comp of annualDetailsService.nonCapComponents(
                                    currentAnnualDetailAssessment?.annualGridComponents,
                                    componentTypes,
                                    viewTaxableValues
                                );
                                track comp
                            ) {
                                <div>
                                    {{ comp.fairMarketValue | number: '1.0-0' }}
                                </div>
                            }
                            <div class="sum-figure"
                                >{{
                                    annualDetailsService.getTotalFMV(
                                        currentAnnualDetailAssessment?.annualGridComponents,
                                        viewTaxableValues
                                    ) | number: '1.0-0'
                                }}
                            </div>
                            @for (
                                comp of annualDetailsService.capComponents(
                                    currentAnnualDetailAssessment?.annualGridComponents,
                                    componentTypes,
                                    viewTaxableValues
                                );
                                track comp;
                                let i = $index
                            ) {
                                <div [ngClass]="{ 'cap-component': i === 0 }"
                                    >{{ comp.fairMarketValue | number: '1.0-0' }}
                                </div>
                            }
                            @if (viewTaxableValues) {
                                @for (
                                    taxableValue of annualDetailsService.taxableValues(
                                        currentAnnualDetailAssessment,
                                        currentAnnualDetailAssessment.taxableValues.length
                                    );
                                    track taxableValue;
                                    let i = $index
                                ) {
                                    <div [ngClass]="{ 'cap-component': i === 0 }">{{ taxableValue }}</div>
                                }
                            }
                        </div>
                    </div>
                </td>
            </tr>
            <!-- Appeal Row -->
            <tr>
                <td class="heading"> Appeals </td>
                <td class="heading">
                    <div>Resolution:</div>
                    <div>Savings:</div>
                </td>
                <td class="clickable" [style.cursor]="notAllowedIfConsolidated">
                    <div
                        class="active.year-appeal-data"
                        (click)="activateViewTarget(ViewTarget.appeal)"
                        [class.strike-thru-savings]="navigationState.staleAppealSavings"
                        [class.strike-thru-status]="navigationState.staleAppealStatus"
                    >
                        @if (currentYear.annualGridDetails.length < 2) {
                            <div class="revision" [style.cursor]="notAllowedIfConsolidated">
                                <div class="appeals-status">
                                    @if (currentYear.annualGridDetails[0].appealStatus !== 'Details') {
                                        <span>{{
                                            currentYear.recalculatedStatus ||
                                                currentYear.annualGridDetails[0].appealStatus
                                        }}</span>
                                    }
                                    @if (currentYear.annualGridDetails[0].appealStatus === 'Details') {
                                        <a style="cursor: pointer">{{
                                            currentYear.recalculatedStatus ||
                                                currentYear.annualGridDetails[0].appealStatus
                                        }}</a>
                                    }
                                </div>
                                <div
                                    class="appeals-savings"
                                    [class.invisible]="!currentYear.annualGridDetails[0].savings"
                                    >{{
                                        annualDetailsService.formatSavings(currentYear.recalculatedSavings) ||
                                            annualDetailsService.formatSavings(currentYear.annualGridDetails[0].savings)
                                    }}
                                </div>
                            </div>
                        }
                        @if (currentYear.annualGridDetails.length >= 2) {
                            <div class="revision" [style.cursor]="notAllowedIfConsolidated">
                                <div class="appeals-status">
                                    @if (currentYear.collapsedAppealStatus !== 'Details') {
                                        <span>{{
                                            currentYear.recalculatedStatus || currentYear.collapsedAppealStatus
                                        }}</span>
                                    }
                                    @if (currentYear.collapsedAppealStatus === 'Details') {
                                        <a style="cursor: pointer">{{
                                            currentYear.recalculatedStatus || currentYear.collapsedAppealStatus
                                        }}</a>
                                    }
                                </div>
                                <div class="appeals-savings" [class.invisible]="!currentYear.collapsedSavings">
                                    @if (currentYear.recalculatedSavings) {
                                        <span>{{
                                            annualDetailsService.formatSavings(currentYear.recalculatedSavings)
                                        }}</span>
                                    }
                                    @if (!currentYear.recalculatedSavings && currentYear.collapsedSavings) {
                                        <span>{{
                                            annualDetailsService.formatSavings(currentYear.collapsedSavings)
                                        }}</span>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </td>
            </tr>
            <!-- Tax Row -->
            <tr>
                <td class="heading" [class.not-actual]="notReceived()"> Taxes </td>
                <td class="heading" [class.not-actual]="notReceived()" style="padding-top: 16px">
                    <div>Total:</div>
                    <div>Eff. Rate:</div>
                    @if (isViewTrueRateBaseRateEnabled) {
                        <div>Base Rate:</div>
                    }
                </td>
                <td
                    class="clickable"
                    [class.not-actual]="notReceived()"
                    style="padding-right: 0px; padding-top: 16px; padding-bottom: 8px"
                    [style.cursor]="notAllowedIfConsolidated"
                >
                    <div
                        class="revision"
                        (click)="activateViewTarget(ViewTarget.tax)"
                        style="padding-top: 0; padding-bottom: 0"
                        [style.cursor]="notAllowedIfConsolidated"
                    >
                        <div>{{ currentYear.totalTaxes | currency: 'USD' }}</div>
                        <div>{{ currentYear.effectiveRate | number: '1.6-6' }}%</div>
                        @if (isViewTrueRateBaseRateEnabled) {
                            <div>{{ currentYear.trueRateBaseRate | number: '1.6-6' }}%</div>
                        }
                    </div>
                </td>
            </tr>
            <!-- Budget Row -->
            @if (budgetsEnabled) {
                <tr>
                    <td class="heading"> Budget </td>
                    <td class="heading" style="padding-top: 16px"></td>
                    <td
                        class="clickable"
                        style="padding-right: 0px; padding-top: 16px; padding-bottom: 8px"
                        (click)="activateViewTarget(ViewTarget.budget)"
                    >
                        @if (currentYear.latestBudgetId > 0) {
                            <div class="revision" style="padding-top: 0; padding-bottom: 0">
                                <div>{{ currentYear.latestBudgetAmount | currency: 'USD' }}</div>
                            </div>
                        }
                    </td>
                </tr>
            }
        </tbody>
    </table>
}
